














import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import BannerImage from '../banner-image.vue';
import { BannerConfig, BannerType } from '../../types';

@Component({
  components: {
    BannerImage,
  },
})
export default class Tile extends Vue {
  /** banner数据 */
  @Prop({ default: [] }) bannerListData!: BannerConfig[];
  /** 是否支持重复曝光上报 */
  @Prop({ default: true }) isMultBrow!: Boolean;

  /** 在template中使用 */
  bannerType = BannerType.tile;

  /** 往外抛事件 */
  @Emit('click')
  eEmitClick(item: BannerConfig) {
    return item;
  }
}
